import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// Prerendered (react-snap) head tags are re-created by React 19 on the client
// render below; drop the static copies first so <head> never has duplicates.
document.querySelectorAll('head [data-seo], head [data-rh]').forEach((el) => el.remove());

// Always client-render with createRoot. Hydration over react-snap HTML caused
// React #418 mismatches (lazy routes); recovery result is identical to a clean
// client render, so createRoot gives the same UX with zero console errors.
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
